import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { File } from './file';
import { InsuranceCertificate } from './insurance-certificate';
import { User } from './user';

export class CompanyVendorFile extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static CompanyVendorFileProperties: (
    | {
        property: keyof CompanyVendorFile;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof CompanyVendorFile;
        type: 'alias';
      }
    | {
        property: keyof CompanyVendorFile;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'CompanyVendorId', type: 'column', dataType: 'number' },
    { property: 'VendorId', type: 'column', dataType: 'number' },
    { property: 'CompanyId', type: 'column', dataType: 'number' },
    { property: 'FileId', type: 'column', dataType: 'number' },
    { property: 'createdBy', type: 'column', dataType: 'number' },
    { property: 'updatedBy', type: 'column', dataType: 'number' },
    { property: 'docType', type: 'column', dataType: 'string' },
    { property: 'permission', type: 'column', dataType: 'string' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },
    { property: 'isArchived', type: 'column', dataType: 'boolean' },
    { property: 'ExemptVendorId', type: 'column', dataType: 'number' },
    {
      property: 'ClientRegisteredVendorId',
      type: 'column',
      dataType: 'number'
    },

    { property: 'File', model: 'File', type: 'association' },
    { property: 'User', model: 'User', type: 'association' },
    {
      property: 'InsuranceCertificates',
      model: 'InsuranceCertificate',
      type: 'association'
    }
  ];

  static {
    CompanyVendorFile.CompanyVendorFileProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        CompanyVendorFile.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        CompanyVendorFile.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        CompanyVendorFile.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(CompanyVendorFileObject: Partial<CompanyVendorFile>) {
    super();

    CompanyVendorFile.CompanyVendorFileProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = CompanyVendorFileObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  CompanyVendorId?: number;
  VendorId?: number | null;
  CompanyId?: number;
  FileId?: number;
  createdBy?: number | null;
  updatedBy?: number | null;
  docType?: string;
  permission?:
    | ('ALL' | 'ADMIN' | 'VENDOR' | 'CLIENT' | 'CLIENT_ADMIN' | 'VENDOR_ADMIN')
    | null;
  createdAt?: Date;
  updatedAt?: Date;
  isArchived?: boolean;
  ExemptVendorId?: number | null;
  ClientRegisteredVendorId?: number | null;

  File?: File;
  User?: User;
  InsuranceCertificates?: InsuranceCertificate[];
}
